module.exports = __webpack_public_path__ + "static/media/20ECE11.ae539bb8.jpg";